angular.module('treeView', []);

angular.module('treeView')
.component('treeView', {
  template: require('./treeview.html'),
  bindings: {
    model: '<',
    nodeSelected: '&',
    nodeExpanded: '&',
    nodeCollapsed: '&'
  },
  controller: [
    function() {
      var $ctrl = this;
      $ctrl.items = [];

      $ctrl.$onInit = function() {
        $ctrl.rand = parseInt(Math.random() * 1000);
        $ctrl.items = $ctrl.model.getTree();
      };

      $ctrl.expandNode = function(node) {
        node.collapsed = false;
        $ctrl.nodeExpanded({node: node});
      };

      $ctrl.collapseNode = function(node) {
        node.collapsed = true;
        $ctrl.nodeCollapsed({node: node});
      };

      $ctrl.selectNode = function(node) {
        node.collapsed = false;
        $ctrl.nodeSelected({node: node});
      };

    }
  ]
});



// WEBPACK FOOTER //
// ./src/lib/treeview/treeview.js